import request from '@/utils/request';

export function appListAPI() {
    return {
        // 列表
        getAppList: params => {
            return request({
                url: 'admin/microapp/select',
                method: 'get',
                params,
            });
        },
        // 添加/修改
        addOrUpdateApp: params => {
            return request({
                url: 'admin/mapps/edit',
                method: 'post',
                data: params,
            });
        },
        // 详情
        getAppInfo: id => {
            return request({
                url: `admin/mapps/info?id=${id}`,
                method: 'get'
            })
        },
        //证书选择
        CertsList: params => {
            return request({
                url: 'admin/mapps/certs',
                method: 'get',
                params,
            });
        },
        //编辑支付证书
        editMappsCerts: params => {
            return request({
                url: 'admin/mapps/edit_mapps_certs',
                method: 'post',
                params,
            });
        },

        //编辑审核开关
        editQuickSwitch: params => {
            return request({
                url: 'admin/mapps/edit_mapps_switch',
                method: 'post',
                params,
            });
        },
    };
}
